import {OLE_PEOPLE_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    peoples: []
};

const olePeoplesReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case OLE_PEOPLE_DATA: {
            return {
                ...state,
                peoples: action.payload,
            }
        }
        default:
            return state;
    }
}

export default olePeoplesReducer;
